import React from 'react';
import Plot from 'react-plotly.js';
import * as Const from '../../../utils/Const';

interface TrainingRankingProps {
  data?: any; // 引数として渡すプロパティ
}

function transformToPlotlyData(sqlData: any[]) {
  if (!sqlData || sqlData.length === 0) return { header: [], columns: [[]] };

  // ヘッダーを取得
  const header = Object.keys(sqlData[0]);

  // 列単位のデータを生成
  const columns = header.map((key) => sqlData.map((row) => row[key]));

  return { header, columns };
}

export const TrainingRanking: React.FC<TrainingRankingProps> = ({ data }) => {
  const dataList = data?.slice(0, 5) || [];
  const plotlyData = transformToPlotlyData(dataList);

  var headerColor = `${Const.BackGroundMainColor}`;
  var rowEvenColor = `${Const.RankingRowBaseColor}`;
  var rowEvenColor = `${Const.RankingRowSubColor}`;
  var rowOddColor = `${Const.BackGroundMainColor}`;
  const cellColors = () => {
    const list = [];
    for (let i = 0; i < plotlyData.columns[0].length; i++) {
      if (i % 2 === 0) {
        list.push(rowOddColor);
      } else {
        list.push(rowEvenColor);
      }
    }
    return list;
  };

  const graphData: any[] = [
    {
      type: 'table',
      header: {
        values: [['<b>順位</b>'], ['<b>ユーザー</b>'], ['<b>正解数</b>'], ['<b>閲覧時間(秒)</b>']],
        align: 'center',
        valign: 'middle',
        line: { width: 0, color: '' },
        fill: { color: headerColor },
        font: { size: 35, color: 'black' },
      },
      cells: {
        values: plotlyData.columns,
        align: 'center',
        valign: 'middle',
        xanchor: 'center',
        line: { width: 0, color: '' },
        fill: {
          color: [cellColors()],
        },
        font: {
          size: 50,
          color: ['black'],
        },
        weight: 'lighter',
        height: 55,
      },
    },
  ];

  if (dataList.length === 0) return <></>;

  return (
    <>
      <details className="rounded-3xl shadow-custom-lg overflow-hidden bg-white ml-2 mr-4 mt-2 mb-8">
        <summary className="cursor-pointer px-4 py-3 text-4xl">正解数ランキング (TOP5)</summary>
        <Plot
          data={graphData}
          layout={{
            margin: {
              t: 20, // 上部のマージンを確保
              l: 10,
              r: 10,
              b: 10,
            },
            autosize: true,
          }}
          config={{
            responsive: true, // レスポンシブデザインを有効にする
            displayModeBar: false, // モードバーを非表示にする
            displaylogo: false, // Plotlyロゴを非表示にする
            staticPlot: true, // プロットを静的にする
          }}
          style={{ width: '100%', height: '100%', minHeight: '450px' }}
        />
      </details>
    </>
  );
};
